import React from 'react'
import { SVGImage, preProcessorCurrentColor } from 'utils/svgHelper'

import folderInboxIcon from 'assets/images/mailbox/folder-inbox.svg'
import folderSentIcon from 'assets/images/mailbox/folder-sent.svg'
import folderScheduleIcon from 'assets/images/mailbox/folder-schedule-send.svg'
import folderDraftsIcon from 'assets/images/mailbox/folder-drafts.svg'
import folderTrashIcon from 'assets/images/mailbox/folder-trash.svg'
import folderArchiveIcon from 'assets/images/mailbox/folder-archive.svg'
import folderJunkIcon from 'assets/images/mailbox/folder-junk.svg'
import folderGeneralIcon from 'assets/images/mailbox/folder-general.svg'
import folderUnreadIcon from 'assets/images/mailbox/folder-unread.svg'
import folderFlaggedIcon from 'assets/images/mailbox/folder-flagged.svg'
import folderSpamIcon from 'assets/images/mailbox/folder-spam-sniper.png'
// import folderNotesIcon from 'assets/images/mailbox/folder-notes.svg'

import chevronRightIcon from 'assets/images/mailbox/chevron-right-24.svg'
import chevronDownIcon from 'assets/images/mailbox/chevron-down-24.svg'
import chevronRight16Icon from 'assets/images/mailbox/chevron-right-16.svg'
import chevronDown16Icon from 'assets/images/mailbox/chevron-down-16.svg'
import toolbarMore24 from 'assets/images/toolbar-more-24.svg'
import toolbarEdit24 from 'assets/images/toolbar-edit.svg'
import toolbarDelete24 from 'assets/images/toolbar-delete.svg'

export function getMenuIcon(type: string, title?: string): React.ReactElement | null {
  switch (type) {
    case 'chevron-right':
      return (
        <SVGImage
          key="right"
          src={chevronRightIcon}
          preProcessor={preProcessorCurrentColor}
          title={title}
        />
      )
    case 'chevron-down':
      return (
        <SVGImage
          key="down"
          src={chevronDownIcon}
          preProcessor={preProcessorCurrentColor}
          title={title}
        />
      )
    case 'chevron-right-16':
      return (
        <SVGImage
          key="right16"
          src={chevronRight16Icon}
          preProcessor={preProcessorCurrentColor}
          title={title}
        />
      )
    case 'chevron-down-16':
      return (
        <SVGImage
          key="down16"
          src={chevronDown16Icon}
          preProcessor={preProcessorCurrentColor}
          title={title}
        />
      )
    case 'toolbar-more':
      return (
        <SVGImage
          key="more"
          src={toolbarMore24}
          preProcessor={preProcessorCurrentColor}
          title={title}
        />
      )
    case 'toolbar-edit':
      return (
        <SVGImage
          key="edit"
          src={toolbarEdit24}
          preProcessor={preProcessorCurrentColor}
          title={title}
        />
      )
    case 'toolbar-delete':
      return (
        <SVGImage
          key="delete"
          src={toolbarDelete24}
          preProcessor={preProcessorCurrentColor}
          title={title}
        />
      )
    default:
      return null
  }
}

export function getImageByRole(
  role: string | null | undefined,
  title?: string,
): React.ReactElement | null {
  const role0 = role != null ? role.toLowerCase() : ''
  let ret: React.ReactElement | null = null
  switch (role0) {
    case 'inbox':
      ret = (
        <SVGImage
          key="inbox"
          src={folderInboxIcon}
          preProcessor={preProcessorCurrentColor}
          title={title || 'inbox'}
        />
      )
      break
    case 'sent':
      ret = (
        <SVGImage
          key="sent"
          src={folderSentIcon}
          preProcessor={preProcessorCurrentColor}
          title={title || 'sent'}
        />
      )
      break
    case 'schedule':
      ret = (
        <SVGImage
          key="schedule"
          src={folderScheduleIcon}
          preProcessor={preProcessorCurrentColor}
          title={title || 'schedule send'}
        />
      )
      break
    case 'spamsniper':
      ret = (
        <img
          key="spamsniper"
          style={{ width: '24px', height: '24px' }}
          src={folderSpamIcon}
          alt={title || 'spam sniper'}
        />
      )
      break
    case 'drafts':
      ret = (
        <SVGImage
          key="drafts"
          src={folderDraftsIcon}
          preProcessor={preProcessorCurrentColor}
          title={title || 'drafts'}
        />
      )
      break
    case 'trash':
      ret = (
        <SVGImage
          key="trash"
          src={folderTrashIcon}
          preProcessor={preProcessorCurrentColor}
          title={title || 'trash'}
        />
      )
      break
    case 'archive':
      ret = (
        <SVGImage
          key="archive"
          src={folderArchiveIcon}
          preProcessor={preProcessorCurrentColor}
          title={title || 'archive'}
        />
      )
      break
    case 'junk':
      ret = (
        <SVGImage
          key="junk"
          src={folderJunkIcon}
          preProcessor={preProcessorCurrentColor}
          title={title || 'junk'}
        />
      )
      break
    case 'unread':
      ret = (
        <SVGImage
          key="unread"
          src={folderUnreadIcon}
          preProcessor={preProcessorCurrentColor}
          title={title || 'unread'}
        />
      )
      break
    case 'flagged':
      ret = (
        <SVGImage
          key="flagged"
          src={folderFlaggedIcon}
          preProcessor={preProcessorCurrentColor}
          title={title || 'flagged'}
        />
      )
      break
    case 'root':
    default:
      ret = (
        <SVGImage
          key="general"
          src={folderGeneralIcon}
          preProcessor={preProcessorCurrentColor}
          title={title || 'general'}
        />
      )
      break
  }

  return ret
}

const IconHelper = {
  getMenuIcon,
  getImageByRole,
}

export default IconHelper
